<template>
  <div class="wrapper">
    <!-- <notifications></notifications> -->
    <side-bar :logo="logo">
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Company Managment',
            icon: 'fas fa-users-cog text-pink',
            path: '/company-management/list'
          }"
          v-if="type == 1"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Site Management',
            icon: 'fas fa-sitemap text-default',
            path: '/site-management/list'
          }"
          v-if="type == 1 || type == 2"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Device Management',
            icon: 'fas fa-laptop text-primary',
            path: '/device-management/list'
          }"
          v-if="type == 1"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'User Management',
            icon: 'fas fa-user-tie text-green',
            path: '/user-management/list'
          }"
          v-if="type == 1 || type == 2"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Question',
            icon: 'fas fa-question-circle text-orange',
            path: '/question/list'
          }"
          v-if="type == 2"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Questionnaires',
            icon: 'fas fa-file-invoice text-info',
            path: '/questionnaires/list'
          }"
          v-if="type == 2"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Questionnaire Questions',
            // icon: 'fas fa-ban text-green',
            icon: 'fas fa-file-signature text-green',
            path: '/questionnaire-questions/list'
          }"
          v-if="type == 2 || type == 4"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Assign Questionnaires to the site',
            icon: 'fas fa-share-square text-default',
            path: '/assign-questionnaires-to-the-site/list'
          }"
          v-if="type == 2 || type == 4"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Visitor Request Approval',
            icon: 'fas fa-clipboard-check text-info',
            path: '/visitor-request-approval/list'
          }"
          v-if="type == 2 || type == 4 || type == 6"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Visitor',
            icon: 'fas fa-id-card-alt text-green',
            path: '/visitor'
          }"
          v-if="type == ''"
        ></sidebar-item>
        <!--<sidebar-item
          :link="{
            name: 'My Request',
            icon: 'fas fa-file-signature text-red',
            path: '/my-request/list'
          }"
          v-if="type == 3 "
        ></sidebar-item>-->
        <sidebar-item
          :link="{
            name: 'Visitor Management',
            icon: 'fas fa-address-card text-red',
            path: '/visitor-management'
          }"
          v-if="type == 4 || type == 5"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Edit Profile',
            icon: 'fas fa-user-cog text-red',
            path: '/visitor-edit-profile'
          }"
          v-if="type == 3"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Group Management',
            icon: 'fas fa-users-cog text-blue',
            path: '/group-management/list'
          }"
          v-if="type == 3"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Report',
            icon: 'fas fa-file-alt text-orange',
            path: '/report'
          }"
          v-if="type == 1 || type == 2 || type == 4 || type == 6"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Document Type',
            icon: 'fas fa-file-alt text-blue',
            path: '/document-management/list'
          }"
          v-if="type == 1"
        ></sidebar-item>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div class="content-area" @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import state from "../../store/state";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import { FadeTransition } from "vue2-transitions";
import jsondata from "assets/json/data.json";
import {mapGetters} from "vuex";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition
  },
  data() {
    return {
      data: jsondata,
      logo: '',
    };
  },
  computed: {
      ...mapGetters({
        type: "type",
        login: "login",
      }),
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    }
  },
  mounted() {
      if(this.login.Logo){
          this.logo = state.mediaURL +  this.login.Logo;
      }
      // this.logo = 'https://static1.squarespace.com/static/5134cbefe4b0c6fb04df8065/t/5bd1e161419202b8ab974c21/1582743997338/squarespace-logo-horizontal-black.jpg';
    this.initScrollbar();
  }
};
</script>
<style lang="scss">
</style>
